<template>
  <v-app id="inspire">
    <Header type="return-search"/>
    <v-main class="grey lighten-3">
      <v-container>
        <v-row>

          <Menu/>

          <v-container class="col-11">
            <v-row>
              <v-col
                  class="page-top d-flex justify-space-between"
                  cols="12"
              >
                <div>
                  <div class="page-title">{{ productInfo.data.name }}</div>
                  <div class="breadcrumb"><span class="breadcrumb-bold">Клиенты / Карточка клиента /</span> {{ productInfo.data.type === 'membership' ? 'Членство' : 'Пакет' }}</div>
                </div>
              </v-col>
            </v-row>

              <v-row style="margin-bottom:20px; background-color: #fff; border-radius:12px;">
                <v-col class="mt-5 col-12">
                  <div class="d-flex justify-space-between">

                    <div class="d-flex" style="align-items: center;">
                      <div style="font-weight:bold;">Статус клиента членства</div>
                      <div v-if="productInfo.data.status === 'Активен'"
                      style="display: flex; align-items: center; justify-content: center; padding:10px; width:200px; border-radius: 12px; background-color: #629F33; margin-left:15px; color:#fff;"
                      >
                          Активен до {{ productInfo.data.dateend.split('T')[0] }}
                      </div>
                      
                      <div v-else-if="productInfo.data.status === 'Заморожен'"
                      style="display: flex; align-items: center; justify-content: center; height:40px; width:200px; border-radius: 12px; background-color: #B2C5FF; margin-left:15px;"
                      
                      >
                          Заморозка до {{ productInfo.data.dateendstatus.split('T')[0] }}
                      </div>
                      <div v-else-if="productInfo.data.status === 'Закрыт'"
                      style="display: flex; align-items: center; justify-content: center; height:40px; width:200px; border-radius: 12px; background-color: #ff0d00; margin-left:15px; color:#fff;"
                      
                      >
                          Закрыт
                      </div>

                      <v-btn
                        v-if="productInfo.data.status === 'Активен'"
                          :class="getClass(productInfo.data.status)"
                          @click="modalBlock = true"
                          style="margin-left:10px;"
                      >
                        Заблокировать
                      </v-btn>

                    </div>


                    <div class="d-flex">
                      <v-btn
                          v-if="productInfo.data.status === 'Продан'"
                          @click="activateProduct(productInfo.data.service.id)"
                          :class="getClass(productInfo.data.status)"
                      >
                        {{ getNameStatus(productInfo.data.status)}}
                      </v-btn>
<!-- 
                      <v-btn
                          v-if="productInfo.data.status === 'Активен'"
                          @click="activateProduct(productInfo.data.service.id)"
                          :class="getClass(productInfo.data.status)"
                      >
                        {{ getNameStatus(productInfo.data.status)}}
                      </v-btn> -->

                      <v-btn
                        v-if="productInfo.data.status === 'Активен'"
                          :class="getClass(productInfo.data.status)"
                          :to="{ name: 'FreezePackage', params: {
                            client_id: productInfo.data.client.id,
                            product_id: productInfo.data.id
                          }}"
                      >
                        Заморозить
                      </v-btn>

                      <v-btn
                          v-if="productInfo.data.status === 'Заморожен'"
                          :to="getRoute(productInfo.data.status,productInfo.data.service.id)"
                          :class="getClass(productInfo.data.status)"
                      >
                        {{ getNameStatus(productInfo.data.status)}}
                      </v-btn>

                      <!--
                                 :to="{ name: 'CardSubscribeHistory', params: {
                            client_id: productInfo.data.client.id,
                            product_id: productInfo.data.id,
                            product_name: productInfo.data.name,
                          }}"
                      -->
                      <v-btn
                          class="button__lighten"
                          style="margin-left:15px;"
                          @click="modalHistory = true"
                      >
                        <img src="/playground_assets/clock-logo.svg" class="mr-1" alt="">
                        История
                      </v-btn>

                          <v-btn
                                class="button__lighten ml-3"
                                @click="modalDelete = true"
                            >
                          <v-icon small class="mr-2">mdi-trash-can-outline</v-icon>
                              Удалить
                          </v-btn>

                          <button
                            class="button button__success"
                            ref="activator"
                            @click="$router.go(-1)"
                            style="margin-left:15px;"
                        >
                          Сохранить
                        </button>

                    </div>

                  </div>
                </v-col>
              </v-row>
              <v-row style="margin-bottom:20px; background-color: #fff; border-radius:12px;">
                <v-col class="mt-5 col-12" style="margin-top:0px !important;">
                  <div class="d-flex" style="align-items: center;">
                    <div style="font-weight:bold;">Клиент</div>
         
                    <v-btn
                          class=""
                          :to="{ name: 'CardClient', params: {client_id: client_id} }"
                          style="text-transform: none; font-weight:bold !important; color:#000 !important; background-color: transparent !important; border:1px solid #e0e0e0 !important; margin-left: 15px; border-radius: 12px; box-shadow: none;"
                      >
                      {{ productInfo.data.client.name }}
                      </v-btn>

                      <div style="margin-left:10px;" v-if="productInfo && productInfo.data && productInfo.data.change_owners_history && productInfo.data.change_owners_history.date">
                              <router-link
                                :to="{ name: 'ChangeOwner', params: {
                                    client_id: productInfo.data.client.id,
                                    product_id: productInfo.data.id,
                                    product_name: productInfo.data.name,
                                    change_type: 'owner',
                                    change_owner_new_client:productInfo.data.change_owners_history.client,
                                    change_owner_new_client_to:productInfo.data.client
                                  }}"
                                      style="text-decoration: none; color: black"
                                  >
                                  Смена владельца от {{ productInfo.data.change_owners_history.date }}
                              </router-link>
                      </div>
                   
                    <div style="margin-left: 20px;">
                      <v-btn
                          class="button__lighten"
                          :to="{ name: 'ChangeOwner', params: {
                            client_id: productInfo.data.client.id,
                            product_id: productInfo.data.id,
                            product_name: productInfo.data.name,
                            change_type: 'owner'
                          }}"
                      >
                        Сменить владельца
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <div class="row d-flex" style="
              align-items: center; 
              justify-content: space-between;
              border:1px solid #e0e0e0;
              margin-bottom: 0px;
              height: 50px;
              padding:15px;
              border-top-right-radius: 8px;
              border-top-left-radius: 8px;

              ">
                  <div class="list-item__title">
                      Долг
                    </div>
                    <div v-if="productInfo && productInfo.data && productInfo.data.debt_history && productInfo.data.debt_history.history && productInfo.data.debt_history.history.length > 0">
                      <!-- {{calculateDebt(productInfo.data.debt_history)}} -->
                      {{ productInfo.data.debt_history.general }}
                    </div>
                    <div v-else>
                      0,00
                    </div>
                </div>
              <v-sheet  v-if="productInfo && productInfo.data && productInfo.data.debt_history && productInfo.data.debt_history.history && productInfo.data.debt_history.history.length > 0" rounded="lg" class="mt-5 col-12" style="margin-left:-12px; margin-right:-12px; width:auto; padding: 0 !important; margin-top:0px !important; border-radius: 0px !important;    max-width: initial;">
   
                <v-list-item v-for="debt in productInfo.data.debt_history.history" :key="debt.document.id">
                  <v-list-item-content class="d-flex">
                    <div class="list-item__title" v-if="debt.document.id">
                      
                          <router-link
                                      :to="{name: 'Sale', params: {client: productInfo.data.client, buy_id: debt.document.id, type: 'exist', for: 'client', deal: null}}"
                                      style="text-decoration: none; color: black"
                                  >
                                  {{debt.date}}  {{debt.document.name}} 
                              </router-link>
                    </div>
                    <div class="list-item__title" v-else>
                      {{debt.date}}  {{debt.document.name}} 
                    </div>
                    <div class="list-item__value">
                      {{debt.sum}}
                    </div>
                  </v-list-item-content>
                </v-list-item>
                <v-divider></v-divider>

              </v-sheet>

              <v-sheet  v-else rounded="lg" class="mt-5 col-12" style="margin-left:-12px; margin-right:-12px; width:auto; padding: 0 !important; margin-top:0px !important; border-radius: 0px !important;     max-width: initial;">
   
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Нет долгов
                  </div>
                  <div class="list-item__value">
                   
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-sheet>


            <v-row style="margin-top:20px; margin-bottom:20px; background-color: #fff; border-radius:12px;">
                <v-col class="mt-5 col-12" style="margin-top:0px !important;">
                  <div class="d-flex" style="align-items: center;">
                    <div style="font-weight:bold;">Номенклатура</div>
                    <div style="font-weight:bold; margin-left: 20px; display: flex; align-items: center; border:1px solid #e0e0e0; border-radius: 12px; padding: 8px 15px 8px 15px;">
                      {{ productInfo.data.service.name }}
                    </div>
                    <div style="margin-left: 20px;">
                      <v-btn
                          class="button__lighten"
                          :to="{ name: 'ChangeOwner', params: {
                            client_id: productInfo.data.client.id,
                            product_id: productInfo.data.id,
                            product_name: productInfo.data.name,
                            change_type: 'nomenclature'
                          }}"
                      >
                        Сменить номенклатуру
                      </v-btn>
                    </div>
                  </div>
                </v-col>
              </v-row>

              <!------------------------------------------------------------------------------------------------------------------------------------------------>


              <div class="row d-flex" style="
              align-items: center; 
              justify-content: space-between;
              border:1px solid #e0e0e0;
              margin-bottom: 0px;
              height: 50px;
              padding:15px;
              border-top-right-radius: 8px;
              border-top-left-radius: 8px;

              ">

              
              <div class="list-item__title">
                      Срок
                    </div>
                    <div>
                      {{ productInfo.data.validity_period_history.general }} 
                    </div>
                </div>

              <v-sheet  v-if="productInfo && productInfo.data && productInfo.data.validity_period_history && productInfo.data.validity_period_history.history && productInfo.data.validity_period_history.history.length > 0" rounded="lg" class="mt-5 col-12" style="margin-left:-12px; margin-right:-12px; width:auto; max-width: initial; padding: 0 !important; margin-top:0px !important; border-radius: 0px !important;">
                <!-- <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Включено в членство 
                  </div>
                  <div class="list-item__value">
                    {{ productInfo.data.validity_period_history[0].days }} 
                  </div>
                </v-list-item-content>
              </v-list-item> -->
              <hr style="opacity:0.3">
                <v-list-item v-for="debt in productInfo.data.validity_period_history.history" :key="debt.document.id">
                  <v-list-item-content class="d-flex">
                    <div class="list-item__title">
                      
                      <router-link
                      v-if="debt.document.id && debt.document.id.length > 5"
                                      :to="{name: 'ChangeOwner', params: {
                                            client_id: productInfo.data.client.id,
                                            product_id: productInfo.data.id,
                                            product_name: productInfo.data.name,
                                            product_lastdate: productInfo.data.dateend,
                                            change_type: 'changetime',
                                            changetimedays:getCorrectDays(debt.days),
                                            document_id: debt.document.id,
                                            document_comment: debt.comment,
                                            document_modifier: debt.modifier
                                        }}"
                                      style="text-decoration: none; color: black"
                                  >
                                  {{debt.date}} {{debt.document.name}}
                              </router-link>

                              <div v-else>{{debt.date}} {{debt.document.name}}</div>


                    </div>
                    <div class="list-item__value">
                      {{debt.days}}
                    </div>
                  </v-list-item-content>
                </v-list-item>
                <hr style="opacity:0.3">
                <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                  </div>
                  <div class="list-item__value">
                    <v-btn
                          class="button__lighten"
                          :to="{ name: 'ChangeOwner', params: {
                            client_id: productInfo.data.client.id,
                            product_id: productInfo.data.id,
                            product_name: productInfo.data.name,
                            product_lastdate: productInfo.data.dateend,
                            change_type: 'changetime'
                          }}"
                      >
                        Изменить
                      </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
              </v-sheet>

              <v-sheet  v-else rounded="lg" class="mt-5 col-12" style="margin-left:-12px; margin-right:-12px; width:auto; max-width: initial; padding: 0 !important; margin-top:0px !important; border-radius: 0px !important;">
                <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Включено в членство 
                  </div>
                  <div class="list-item__value">
                    {{ productInfo.data.daysleft }} (остаток)
                  </div>
                </v-list-item-content>
              </v-list-item>
              <hr style="opacity:0.3">
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Нет изменений по продукту
                  </div>
                  <div class="list-item__value">
                   
                  </div>
                </v-list-item-content>
              </v-list-item>
              <hr style="opacity:0.3">
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                  </div>
                  <div class="list-item__value">
                    <v-btn
                    v-if="productInfo.data.status === 'Закрыт'"
                          class="button__lighten"
                          :to="{ name: 'ChangeOwner', params: {
                            client_id: productInfo.data.client.id,
                            product_id: productInfo.data.id,
                            product_name: productInfo.data.name,
                            product_lastdate: productInfo.data.dateend,
                            change_type: 'changetime',
                            closed_service_id:productInfo.data.service.id,
                            closed_service_name:productInfo.data.service.name
                          }}"
                      >
                        Изменить
                      </v-btn>
                      <v-btn
                    v-else
                          class="button__lighten"
                          :to="{ name: 'ChangeOwner', params: {
                            client_id: productInfo.data.client.id,
                            product_id: productInfo.data.id,
                            product_name: productInfo.data.name,
                            product_lastdate: productInfo.data.dateend,
                            change_type: 'changetime'
                          }}"
                      >
                        Изменить
                      </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-sheet>

            <!------------------------------------------------------------------------------------------------------------------------------------------------>

             <!------------------------------------------------------------------------------------------------------------------------------------------------>


             <div class="row d-flex" style="
              align-items: center; 
              justify-content: space-between;
              border:1px solid #e0e0e0;
              margin-top:20px; margin-bottom:1px;
              height: 50px;
              padding:15px;
              border-top-right-radius: 8px;
              border-top-left-radius: 8px;

              ">
              <div class="list-item__title">
                      Договоры
                    </div>
      
              </div>
              <v-sheet  v-if="contractList && contractList.data && contractList.data.length > 0" rounded="lg" class="mt-5 col-12" style="margin-left:-12px; margin-right:-12px; width:auto; max-width: initial; padding: 0 !important; margin-top:0px !important; border-radius: 0px !important;">
     
                <v-list-item v-for="debt in contractList.data" :key="debt.contract.id">
                  <v-list-item-content class="d-flex">
                    <div class="list-item__title" style="width:100%; cursor:pointer;" @click="printContract(debt.contract.id)">
                      {{debt.contract.name}}
                                            <v-progress-circular
                                              v-if="printLoading"
                                              color="green"
                                              indeterminate
                                              style="width:20px; height:20px;"
                                            ></v-progress-circular>
                    </div>
                    <div class="list-item__value">
                    </div>
                  </v-list-item-content>
                </v-list-item>
                <hr style="opacity:0.3">
                <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                  </div>
                  <div class="list-item__value">
                    <!-- <v-btn
                          class="button__lighten"
                  
                      >
                        Добавить
                      </v-btn>
                       -->
                  </div>
                </v-list-item-content>
              </v-list-item>
              </v-sheet>

              <v-sheet  v-else rounded="lg" class="mt-5 col-12" style="margin-left:-12px; margin-right:-12px; width:auto; max-width: initial; padding: 0 !important; margin-top:0px !important; border-radius: 0px !important;">
   
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Нет договоров
                  </div>
                  <div class="list-item__value">
                   
                  </div>
                </v-list-item-content>
              </v-list-item>
              <hr style="opacity:0.3">
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                  </div>
                  <div class="list-item__value">
                    <!-- <v-btn
                          class="button__lighten"
              
                      >
                      Добавить
                      </v-btn> -->
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-sheet>

              <!------------------------------------------------------------------------------------------------------------------------------------------------>


            <div class="row d-flex" style="
              align-items: center; 
              justify-content: space-between;
              border:1px solid #e0e0e0;
              margin-top:20px; margin-bottom:1px;
              height: 50px;
              padding:15px;
              border-top-right-radius: 8px;
              border-top-left-radius: 8px;

              ">
              <div class="list-item__title">
                      Заморозки
                    </div>
                    <div>
                      {{ productInfo.data.frost_history.general }}
                    </div>
              </div>
              <!-- <v-sheet  v-if="freezeList && freezeList.data && freezeList.data.data && freezeList.data.data.documents && freezeList.data.data.documents.length > 0" rounded="lg" class="mt-5 col-12" style="margin-left:-12px; margin-right:-12px; width:auto; max-width: initial; padding: 0 !important; margin-top:0px !important; border-radius: 0px !important;"> -->
               
              <v-sheet  v-if="productInfo && productInfo.data && productInfo.data.frost_history && productInfo.data.frost_history.history && productInfo.data.frost_history.history.length > 0" rounded="lg" class="mt-5 col-12" style="margin-left:-12px; margin-right:-12px; width:auto; max-width: initial; padding: 0 !important; margin-top:0px !important; border-radius: 0px !important;"> 
                <!-- <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Включено в членство 
                  </div>
                  <div class="list-item__value">
                    {{ productInfo.data.daysfrozentotal }}
                  </div>
                </v-list-item-content>
              </v-list-item> -->
              
                <v-list-item v-for="debt in productInfo.data.frost_history.history" :key="debt.document.id">
                  <hr style="opacity:0.3">
                  <v-list-item-content class="d-flex">
                    <div class="list-item__title">
               

                     <router-link
                      v-if="debt.document.id && debt.document.id.length > 5"
                                      :to="{name: 'FreezePackage', params: {
                                            client_id: productInfo.data.client.id,
                                            product_id: productInfo.data.id,
                                            freezedays:debt.days,
                                            add_days:debt.document.name.split('личен')[1] ? true : false,
                                            document_id:debt.document.id
                                        }}"
                                      style="text-decoration: none; color: black"
                                  >
                                  {{debt.date}} {{debt.document.name}}
                              </router-link>

                              <div v-else>{{debt.date}} {{debt.document.name}}</div>



                    </div>
                    <div class="list-item__value">
                      {{debt.days}}
                    </div>
                  </v-list-item-content>
                </v-list-item>
                <hr style="opacity:0.3">
                <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                  </div>
                  <div class="list-item__value">
                    <v-btn
                        v-if="productInfo.data.status === 'Заморожен'"
                          class="button__lighten"
                          :to="{ name: 'FreezePackage', params: {
                            client_id: productInfo.data.client.id,
                            product_id: productInfo.data.id,
                            add_days:true
                          }}"
                      >
                        Добавить
                      </v-btn>
                      <v-btn
                        v-else
                          class="button__lighten"
                          :to="{ name: 'FreezePackage', params: {
                            client_id: productInfo.data.client.id,
                            product_id: productInfo.data.id,
                            add_days:true
                          }}"
                      >
                        Добавить
                      </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
              </v-sheet>

              <v-sheet  v-else rounded="lg" class="mt-5 col-12" style="margin-left:-12px; margin-right:-12px; width:auto; max-width: initial; padding: 0 !important; margin-top:0px !important; border-radius: 0px !important;">
   
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Нет заморозок
                  </div>
                  <div class="list-item__value">
                   
                  </div>
                </v-list-item-content>
              </v-list-item>
              <hr style="opacity:0.3">
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                  </div>
                  <div class="list-item__value">
                    <v-btn
                        v-if="productInfo.data.status === 'Заморожен'"
                          class="button__lighten"
                          :to="{ name: 'UnfreezePackage', params: {
                            client_id: productInfo.data.client.id,
                            product_id: productInfo.data.id
                          }}"
                      >
                        Добавить
                      </v-btn>
                      <v-btn
                        v-else
                          class="button__lighten"
                          :to="{ name: 'FreezePackage', params: {
                            client_id: productInfo.data.client.id,
                            product_id: productInfo.data.id
                          }}"
                      >
                        Добавить
                      </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-sheet>

            <!------------------------------------------------------------------------------------------------------------------------------------------------>

             <!------------------------------------------------------------------------------------------------------------------------------------------------>


             <div class="row d-flex" style="
              align-items: center; 
              justify-content: space-between;
              border:1px solid #e0e0e0;
              margin-top:20px; margin-bottom:1px;
              height: 50px;
              padding:15px;
              border-top-right-radius: 8px;
              border-top-left-radius: 8px;

              ">
              <div class="list-item__title">
                      Услуги
                    </div>
                    <div>
                      Остаток
                    </div>
              </div>
              <v-sheet  v-if="productInfo && productInfo.data && productInfo.data.servicelist && productInfo.data.servicelist.length > 0" rounded="lg" class="mt-5 col-12" style="margin-left:-12px; margin-right:-12px; width:auto; max-width: initial; padding: 0 !important; margin-top:0px !important; border-radius: 0px !important;">
 
              
                <v-list-item v-for="debt in productInfo.data.servicelist" :key="debt.id">
                  
                  <v-list-item-content class="d-flex">
        

                    <div class="list-item__title">
                      
                      <router-link
                      v-if="debt.id && debt.id.length > 5"
                                      :to="{name: 'ChangeOwner', params: {
                                            client_id: productInfo.data.client.id,
                                            product_id: productInfo.data.id,
                                            product_name: productInfo.data.name,
                                            change_type: 'add_service',
                                            change_type_product: {id:debt.id,name:debt.name},
                                            document_id: debt.id,
                                            document_comment: debt.comment,
                                        }}"
                                      style="text-decoration: none; color: black"
                                  >
                                 {{debt.name}}
                              </router-link>

                              <div v-else>{{debt.name}}</div>


                    </div>

                    <div class="list-item__value">
                      {{debt.count}}
                    </div>
                  </v-list-item-content>
                </v-list-item>
                <hr style="opacity:0.3">
                <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                  </div>
                  <div class="list-item__value">
                    <v-btn
                          class="button__lighten"
                          :to="{ name: 'ChangeOwner', params: {
                            client_id: productInfo.data.client.id,
                            product_id: productInfo.data.id,
                            change_type: 'add_service'
                          }}"
                      >
                        Добавить
                      </v-btn>
                  
                  </div>
                </v-list-item-content>
              </v-list-item>
              </v-sheet>

              <v-sheet  v-else rounded="lg" class="mt-5 col-12" style="margin-left:-12px; margin-right:-12px; width:auto; max-width: initial; padding: 0 !important; margin-top:0px !important; border-radius: 0px !important;">
   
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Нет услуг
                  </div>
                  <div class="list-item__value">
                   
                  </div>
                </v-list-item-content>
              </v-list-item>
              <hr style="opacity:0.3">
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                  </div>
                  <div class="list-item__value">
                    <v-btn
                        v-if="productInfo.data.status === 'Заморожен'"
                          class="button__lighten"
                          :to="{ name: 'ChangeOwner', params: {
                            client_id: productInfo.data.client.id,
                            product_id: productInfo.data.id,
                            change_type: 'add_service'
                          }}"
                      >
                        Добавить
                      </v-btn>
                 
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-sheet>

            <!------------------------------------------------------------------------------------------------------------------------------------------------>

            <v-row style="margin-top:20px; margin-bottom:20px; background-color: #fff; border-radius:12px;">
                <v-col class="mt-5 col-12" style="margin-top:0px !important;">
                  <div class="d-flex" style="align-items: center;">

                    <div class="d-flex" style="flex-direction:column; width:30%;">
                      <div style="font-weight:bold;">Активация</div>
                      <div style="font-weight:bold;  display: flex; align-items: center; border:1px solid #e0e0e0; border-radius: 12px; padding: 8px 15px 8px 15px;">
                        {{ productInfo.data.dateactivation.split('T')[1] ? productInfo.data.dateactivation.split('T')[0] : productInfo.data.dateactivation}}
                      </div>
                    </div>
                    <div class="d-flex" style="flex-direction:column; width:30%; margin-left: 20px;">
                      <div style="font-weight:bold;">Срок действия (включительно)</div>
                      <div style="font-weight:bold;  display: flex; align-items: center; border:1px solid #e0e0e0; border-radius: 12px; padding: 8px 15px 8px 15px;">
                        {{ productInfo.data.dateend.split('T')[1] ? (productInfo.data.dateend.split('T')[0].split('-')[2] ? productInfo.data.dateend.split('T')[0].split('-')[2]+'.'+productInfo.data.dateend.split('T')[0].split('-')[1]+'.'+productInfo.data.dateend.split('T')[0].split('-')[0] : productInfo.data.dateend) : (productInfo.data.dateend.split('-')[2] ? productInfo.data.dateend.split('-')[2]+'.'+productInfo.data.dateend.split('-')[1]+'.'+productInfo.data.dateend.split('-')[0] : productInfo.data.dateend) }}
                      </div>
                    </div>

                    <div class="d-flex" style="flex-direction:column; width:30%; margin-left: 20px;">
                      <div style="font-weight:bold;">Приобретён</div>
                      <div style="font-weight:bold;  display: flex; align-items: center; border:1px solid #e0e0e0; border-radius: 12px; padding: 8px 15px 8px 15px;">
                        {{ productInfo.data.datesale.split('T')[1] ? productInfo.data.datesale.split('T')[0] : productInfo.data.datesale }}
                      </div>
                    </div>
                    
                  </div>
                </v-col>
              </v-row>


    <!------------------------------------------------------------------------------------------------------------------------------------------------>
    <div class="row d-flex" style="
              align-items: center; 
              justify-content: space-between;
              border:1px solid #e0e0e0;
              margin-top:20px; margin-bottom:1px;
              height: 50px;
              padding:15px;
              border-top-right-radius: 8px;
              border-top-left-radius: 8px;

              ">
    <div class="list-item__title">
                      Гостевые посещения
                    </div>
                    <div>
                      {{ productInfo.data.guestvisitleft }}
                    </div>
                </div>

              <v-sheet rounded="lg" class="mt-5 col-12" style="margin-left:-12px; margin-right:-12px; width:auto; max-width: initial; padding: 0 !important; margin-top:0px !important; border-radius: 0px !important; margin-bottom:100px;">
                <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Включено в членство 
                  </div>
                  <div class="list-item__value">
                    {{ productInfo.data.guestvisittotal }}
                  </div>
                </v-list-item-content>
              </v-list-item>
              <hr style="opacity:0.3">
       
                <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                  </div>
                  <div class="list-item__value">
                    <v-btn
                          class="button__lighten"
                          :to="{ name: 'ChangeOwner', params: {
                            client_id: productInfo.data.client.id,
                            product_id: productInfo.data.id,
                            change_type: 'guest_visits'
                          }}"
                      >
                        Добавить
                      </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
              </v-sheet>

            <!------------------------------------------------------------------------------------------------------------------------------------------------>
            <!-- <v-sheet rounded="lg" class="mt-5 col-7" style="padding: 0 !important;">
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Клиент
                  </div>
                  <div class="list-item__value">
                    {{ productInfo.data.client.name }}
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Номенклатура
                  </div>
                  <div class="list-item__value">
                    {{ productInfo.data.service.name }}
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Услуги
                  </div>
                  <div class="list-item__value">
                    {{ productInfo.data.servicelist.length }}
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Активация
                  </div>
                  <div class="list-item__value">
                    <v-btn
                        v-if="productInfo.data.status !== 'Продан'"
                        :to="getRoute(productInfo.data.status,productInfo.data.service.id)"
                        :class="getClass(productInfo.data.status)"
                    >
                      {{ getNameStatus(productInfo.data.status)}}
                    </v-btn>
                    <v-btn
                        v-if="productInfo.data.status === 'Продан'"
                        @click="activateProduct(productInfo.data.service.id)"
                        :class="getClass(productInfo.data.status)"
                    >
                      {{ getNameStatus(productInfo.data.status)}}
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Приобретен
                  </div>
                  <div class="list-item__value">
                    {{ productInfo.data.datesale }}
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Дата активации
                  </div>
                  <div class="list-item__value">
                    {{ productInfo.data.dateactivation }}
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Остаток дней в заморозке
                  </div>
                  <div class="list-item__value">
                    {{ productInfo.data.daysfrozenleft }}
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    История заморозок
                  </div>
                  <div class="list-item__value">
                    <v-btn
                        class="button__lighten"
                        :to="{ name: 'CardSubscribeHistory', params: {
                          client_id: productInfo.data.client.id,
                          product_id: productInfo.data.id,
                          product_name: productInfo.data.name,
                        }}"
                    >
                      <img src="/playground_assets/clock-logo.svg" class="mr-1" alt="">
                      История
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content class="d-flex">
                  <div class="list-item__title">
                    Гостевые посещения
                  </div>
                  <div class="list-item__value">
                    {{ productInfo.data.guestvisittotal }}
                  </div>
                </v-list-item-content>
              </v-list-item>
            </v-sheet> -->
          </v-container>
        </v-row>

        <v-row justify="center">
              <v-dialog
                  v-model="modalHistory"
                  max-width="800px"
              >
                <v-card rounded="lg" v-if="modalHistory">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                      <h4> История </h4>
                    </div>
                    <v-btn icon @click="modalHistory = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="padding-left: 0px !important; padding-right: 0px !important;">
          
                      <div>
                        <v-data-table
                            v-if="historyProductList && historyProductList.history"
                            :headers="headersHistory"
                            :items="historyProductList.history"
                            item-key="id"
                            item-value="id"
                            v-model="selectTag"
                            no-data-text="Ничего не найдено"
                            hide-default-footer
                            disable-pagination
                            class="elevation-1"
                        >
                        <!-- <template v-slot:item.date="{ item }">
                          {{ item.date.split('T')[0] }}
                        </template>

                        <template v-slot:item.document="{ item }">
                          {{ item.date.split('T')[1] }}
                        </template>

                        <template v-slot:item.user="{ item }">
                          <span v-if="item.user">{{ item.name }}</span>
                          <span v-else> '' </span>
                        </template>

                        <template v-slot:item.comment="{ item }">
                          {{ item.comment }}
                        </template> -->

                        </v-data-table>
                     
                      </div>
                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>

            <v-row justify="center">
              <v-dialog
                  v-model="modalDelete"
                  max-width="500px"
              >
                <v-card rounded="lg" v-if="modalDelete">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                    </div>
                    <v-btn icon @click="modalDelete = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="">
          
                      <div style="padding:20px; font-size:20px; font-weight: bold; color:#000;">

                        Пометить {{ productInfo.data.name  }} на удаление?
                     
                      </div>

                      <v-row class="mt-5">
                          <v-card-actions style=" width:100%; display: flex; align-items: center; justify-content: center; padding-bottom: 20px;">
                            <button
                                class="button button__success"
                                ref="activator"
                                style="width:106px; height: 48px;"
                                @click="modalDelete = false"
                            >
                              Да
                            </button>
                            <button
                                class="button button__lighten"
                                ref="activator"
                                style="width:106px; height: 48px; color:#000; margin-left:15px;"
                                @click="modalDelete = false"
                            >
                              Нет
                            </button>
                          </v-card-actions>
                        </v-row>

                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>

            <v-row justify="center">
              <v-dialog
                  v-model="modalBlock"
                  max-width="550px"
              >
                <v-card rounded="lg" v-if="modalBlock">
                  <v-card-title class="justify-space-between">
                    <div></div>
                    <div>
                    </div>
                    <v-btn icon @click="modalBlock = false">
                      <v-icon>mdi-close-circle-outline</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text style="padding: 0 !important;">
                    <v-container style="">
          
                      <div style="padding:20px; font-size:20px; font-weight: bold; color:#000; display:flex; flex-direction: column; align-items: center;">

                        <div style="font-size: 30px;"> Заблокировать</div>
                        <div style="margin:20px 0px;">{{ productInfo.data.name  }}</div>

                        <div> 
                          <span>Количетсво дней: </span>
                          <v-text-field
                                  v-model="productBlockDays"
                                  outlined
                                  dense
                                  style="height: 45px;margin-top: 10px; width:150px; margin-left:0px;"
                                  class="rounded-lg"
                              ></v-text-field>

                        </div>
                     
                      </div>

                      <v-row class="mt-5">
                          <v-card-actions style=" width:100%; display: flex; align-items: center; justify-content: center; padding-bottom: 20px;">
                            <button
                                class="button button__success"
                                ref="activator"
                                style="width:106px; height: 48px;"
                                @click="productBlockDaysSet()"
                                :disabled="(productBlockDays <= 0) ? true : false"
                            >
                              Да
                            </button>
                            <button
                                class="button button__lighten"
                                ref="activator"
                                style="width:106px; height: 48px; color:#000; margin-left:15px;"
                                @click="modalBlock = false"
                            >
                              Нет
                            </button>
                          </v-card-actions>
                        </v-row>

                    </v-container>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-row>

      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import Header from '@/components/Header.vue';
import Menu from '@/components/Menu.vue';
import {mapState} from "vuex";
import {getItem} from '@/helpers/persistanceStorage';
import {setItem} from '@/helpers/persistanceStorage';
import {clientActionTypes} from "@/store/modules/client";
import {receptionActionTypes} from '@/store/modules/reception';
import {salesActionTypes} from "@/store/modules/sale";

export default {
  name: "CardSubscribe",
  props: ['client_id','product_id'],
  components: {
    Header,
    Menu,
  },
  data() {
    return {
      debtsAr:null,
      modalHistory:false,
      headersHistory:[
        {text: '', align: 'start', sortable: false, value: 'date'},
        {text: '', align: 'start', sortable: false, value: 'time'},
        {text: '', align: 'start', sortable: false, value: 'user.name'},
        {text: '', align: 'start', sortable: false, value: 'comment'},
      ],
      modalDelete:false,
      contractList:[],
      printLoading:false,
      productBlockDays:0,
      modalBlock:false
    }
  },
  computed: {
    ...mapState({
      isLoading: state => state.client.isLoading,
      productInfo: state => state.client.productInfo,
      validationErrors: state => state.client.validationErrors,
      freezeList: state => state.client.freezeList,
      historyProductList: state => state.client.productHistory,
    })
  },
  mounted() {
    this.client_id !== undefined ? setItem('card-subscribe-client_id',this.client_id) : this.client_id = getItem('card-subscribe-client_id');
    this.product_id !== undefined ? setItem('card-subscribe-product_id',this.product_id) : this.product_id = getItem('card-subscribe-product_id');
    this.fetchFeed(this.client_id,this.product_id)
    let client_id = this.client_id
    let product_id = this.product_id
    this.$store.dispatch(clientActionTypes.getFreezeList, {client_id, product_id}).then(data => {
        //this.freezeList = data.data
    })
    this.$store.dispatch(clientActionTypes.getContractList, {product_id}).then(data => {
        //this.freezeList = data.data
        if(data){
          this.contractList = data
        }
        console.log(data)
    })
    this.$store.dispatch(clientActionTypes.getProductHistory, {product_id:product_id})
        .then((response) => {
          if(response && response.success){
            //this.dialogCardHistory = true
          } else {
          }
          //this.cardHistoryLoading = false
      })
  },
  methods: {
    productBlockDaysSet(){
      this.$store.dispatch(clientActionTypes.activateProduct, {
        product_id: this.productInfo.data.service.id,
        client_id:this.client_id,
        block:true,
        days:this.productBlockDays
      })
          .then(() => {
            this.$router.push({
                  name: 'CardClient',
                  params: {
                    client_id: this.client_id,
                    product_id:this.product_id
                  }
                });
          })
    },
    getCorrectDays(days){
      let dayRes = 0
      if(days && days !== null) {
        if(days.split(' дн')[1]) {
          dayRes = days.split(' дней')[0]
        }
        if(days.split(' де')[1]) {
          dayRes = days.split(' день')[0]
        }
      }

      return dayRes;
    },
    calculateDebt(debts){

      let result = 0

      result = debts.reduce((res, i) => res + i.sum, 0)

      return result;

    },
    printContract(id){
      this.printLoading = true
              this.$store.dispatch(salesActionTypes.printSale,{
                    file_id: id
                  }).then((response2) => {
                    if (response2 && response2.success) {
                      //печатаем
                      let link = document.createElement('a');
                      link.href = response2.link;
                      link.target = 'a_blank';
                      let filename = 'contract-' + (Math.floor(Date.now() / 1000)) + '.docx';
                      link.setAttribute('download', filename);
                      document.body.appendChild(link);
                      link.click();
                      link.remove();

                      this.printLoading = false

                    } else {
                      alert('Ошибка генерации документа')
                      this.printLoading = false
                    }
                
                  })
    },
    fetchFeed(client_id, product_id) {
      this.$store.dispatch(clientActionTypes.clientProductInfo, {client_id, product_id}).then((response) => {

        if(response && response.data && response.data.service){
          this.$store.dispatch(receptionActionTypes.desktopClient, {client_id}).then((res) => {
            if(res && res.client && res.client.debts){
              this.debtsAr = []
              for(let i = 0; i < res.client.debts.length; i++){
                if(res.client.debts[i].buy_list){
                  for(let j = 0; j < res.client.debts[i].buy_list.length; j++){
                    if(this.productInfo.data.service.id === res.client.debts[i].buy_list[j].id){
                      let debtObj = res.client.debts[i].buy_list[j]
                      debtObj.buy_name = res.client.debts[i].buy ? res.client.debts[i].buy.buy_name : res.client.debts[i].buy_list[j].name
                      this.debtsAr.push(debtObj)
                    }
                  }
                }

              }
            }
          })
        }

      })

    },
    getClass(status) {
      if (status === 'Активен') return 'button__block'
      else if (status === 'Заморожен') return 'button__unblock'
      else if (status === 'Закрыт') return 'button__disabled'
      else if (status === 'Продан') return 'button__activate'
    },
    getRoute(status,product_id){
      if (status === 'Активен') return  {name: 'FreezePackage', params: {client_id: this.client_id, product_id: product_id}}
      else if (status === 'Заморожен')  return  {name: 'UnfreezePackage', params: {client_id: this.client_id, product_id: product_id}}
      else {return {}}
    },
    getNameStatus(status){
      if (status === 'Активен') return 'Заморозить'
      else if (status === 'Заморожен') return 'Разморозить'
      else if (status === 'Продан') return 'Активировать'
      else if (status === 'Закрыт') return 'Закрыт'
    },
    activateProduct(item){
      this.$store.dispatch(clientActionTypes.activateProduct, {
        product_id: item,
        client_id:this.client_id
      })
          .then(() => {
            if (this.tab === 4) {
              this.$store.dispatch(clientActionTypes.getMembership, {
                client_id: this.client_id,
              });
            }
            if (this.tab === 8) {
              this.$store.dispatch(clientActionTypes.getPacks, {
                client_id: this.client_id,
              });
            }
          })
    },
  }
}
</script>

<style scoped>
</style>